// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LDOl","comment":"styles_comment__9s7OX"};